/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return ServiceTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ServiceTypeQueryOperator>): ServiceTypeQueryOperator {
        let obj = Object.assign(new ServiceTypeQueryOperator(), model);
        ServiceTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceTypeQueryOperator>): ServiceTypeQueryOperator {
        if (!model) return null;
        return ServiceTypeQueryOperator.newInstance(<ServiceTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceTypeQueryOperator) {
        if (!obj) return;

        models.ServiceTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service types to include
     */
    service_types: Array<string>;

}
